import { createContext, useContext, useEffect, useState } from 'react';
import { AppHelper } from '../AppHelper';
import { EssayHelper } from '../helpers/essay.helper';
import { UserContext } from './context-user';

const dayjs = require('dayjs');
const EssayContext = createContext();

export const useEssayContext = () =>{
  return useContext(EssayContext);
};

export const EssayProvider = ({ children })=>{
  const { oUser } = useContext(UserContext);
  const [essayList, setEssayList] = useState([]);
  const [isEssayListLoaded, setIsEssayListLoaded] = useState(false);
  const [isEssayListLoading, setIsEssayListLoading] = useState(true);
  const _scoreCodesV2 = [
    { c:'GM', c2: 'grammar', n:'Grammar', v:0, p:0, eg: [], sub: [], expand: false }, 
    { c:'SP', c2: 'spelling', n:'Spelling', v:0, p:0, eg: [], sub: [], expand: false },
    { c:'VC', c2: 'vocabulary', n:'Vocabulary', v:0, p:0, eg: [], sub: [], expand: false }, 
    { c:'ST', c2: 'structure', n:'Structure', v:0, p:0, eg: [], sub: [], expand: false },
  ];
  useEffect(() => {
    if(!oUser) return;
    loadEssayList(oUser);
  }, [oUser]);

  const loadEssayList = async (argUser, argEssayId=null) => {
    if(!argUser) return;
    setIsEssayListLoading(true);
    const [_rulesJsonP1, _rulesJsonP2, _rulesJsonP3, _rulesJsonP4, _rulesJsonP5, _rulesJsonP6, _rulesJsonS1, _rulesJsonS2, _rulesJsonS3, _rulesJsonS4, _rulesJsonS4E, _rulesJsonS5] = await Promise.all([
      EssayHelper.rulesJsonByProfile(argUser.token, 'P1'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'P2'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'P3'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'P4'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'P5'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'P6'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S1'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S2'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S3'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S4'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S4E'),
      EssayHelper.rulesJsonByProfile(argUser.token, 'S5'),
    ]);
    var _rulesJsonList = [
      { code:'P1', data: _rulesJsonP1},
      { code:'P2', data: _rulesJsonP2},
      { code:'P3', data: _rulesJsonP3},
      { code:'P4', data: _rulesJsonP4},
      { code:'P5', data: _rulesJsonP5},
      { code:'P6', data: _rulesJsonP6},
      { code:'S1', data: _rulesJsonS1},
      { code:'S2', data: _rulesJsonS2},
      { code:'S3', data: _rulesJsonS3},
      { code:'S4', data: _rulesJsonS4},
      { code:'S4E', data: _rulesJsonS4E},
      { code:'S5', data: _rulesJsonS5},
    ];
	;
    var _res = await AppHelper.apiPost('api/essay/list/v4', {token: argUser.token, profileId: argUser.profileId});
    if(!_res || !_res.status){
      setIsEssayListLoaded(true);
      setIsEssayListLoading(false);
      setEssayList([]);
      return;
    }
    var _isAnyInProgress = false;
    var _resScoreList = await EssayHelper.essayScoreGet(argUser.token, argUser.profileId, '');
    if(!_resScoreList){
      _resScoreList = [];
    }
    for(var ii=0; ii<_res.data.length; ii++)
    {
      var r = _res.data[ii];
      var _ts = dayjs(r.timestampUtc);
      r.tCode = _ts.format('YYYYMMDDHHmmss');
      r.tTitle = _ts.format("DD MMM YY' hh:mm A");
      r.viewTitle = `${r.topic}`;
	  
      r.version = r.avgScore != null ? 1 : 2;
      var _score = r.version == 1 ? r.avgScore : r.avgScore2;
      if(r.version == 1){
        r.avgScore = parseFloat(_score);
        r.avgScoreP = (r.avgScore / 5)*100;
      }
      else if(r.version == 2){
        var _scores = [..._scoreCodesV2];
        r.version = EssayHelper.scoreVersionNumFromScore(r);

        var _v2TotalScore = 0;
        if(r.version >= 3.0){
          var _rule = _rulesJsonList.find(x=>x.code == r.grade);
          if(_rule){
            var _recScore = _resScoreList.find(x=>x.essayId==r.essayId);
            if(!_recScore){
            }
            else{
              r.avgScoreP = _recScore.overall_score;
            }
          }
          else{
            _scores.forEach(_rScore=>{
              var _arrScRec = r.scores.filter(_x=>_x.scoreCode == _rScore.c);
              const _scSum = _arrScRec.reduce((total, current) => total + current.score, 0);
              _rScore.v = _arrScRec.length > 0 ? (_scSum/_arrScRec.length) : 0;
              _rScore.v = parseFloat(_rScore.v.toFixed(2));
              if(_rScore.c == 'ST'){
                _rScore.v = parseFloat((_rScore.v * 2.5).toFixed(2));
              }
              else if(_rScore.c == 'VC' && _arrScRec.length<2){
                _rScore.v = parseFloat((_rScore.v / 2).toFixed(2));
              }
              _v2TotalScore += _rScore.v;
            });
            r.avgScoreP = (_v2TotalScore / (10*4))*100;
            if(r.version>=4)
              r.avgScoreP = (_v2TotalScore / (10*6))*100;
          }
        }
        else{
          _scores.forEach(_rScore=>{
            var _arrScRec = r.scores.filter(_x=>_x.scoreCode == _rScore.c);
            var _scSum = _arrScRec.reduce((total, current) => total + current.score, 0);
            if((r.version == 3 || r.version == 3.1) && (_rScore.c == 'SP' || _rScore.c == 'GM' || _rScore.c == 'VC')){
              _scSum = _scSum / 2.5;
            }
            _v2TotalScore += _arrScRec.length > 0 ? (_scSum/_arrScRec.length) : 0;
          });
          r.avgScore = parseFloat(_v2TotalScore.toFixed(2));
          r.avgScoreP = (r.avgScore / 16)*100;
        }
      }
      r.versionTitle = r.version == 4.0 ? 'v4.0' 
                        : r.version == 3.1 ? 'v3.1' :r.version == 3 ? 'v3.0' 
                        : r.version == 2.2 ? 'v2.2' : r.version == 2.1 ? 'v2.1' : r.version == 2 ? 'v2.0' : 'v.1.0';

      if(r.status>0 && r.status<5){
        var _diffMinutes = dayjs.utc().diff(dayjs(r.timestampUtc), 'minutes');
        if(_diffMinutes<15){
          r.isInProgress = true;
          _isAnyInProgress = true;
        }
      }
	  
	  r.essayAttempts = [];
	  r.essayAttempt.sort((a, b) => b.attemptId - a.attemptId);

	  for(var j = 0;j < r.essayAttempt.length;j++)
	  {
		  var ra = r.essayAttempt[j];
		 
		  var _ts2 = dayjs(ra.createdOnUTC);
		  ra.createdOnUTC = _ts2.format("DD MMM YY' hh:mm A");
		  r.essayAttempts.push(ra);		 
	  }
	  
	  r.essayAttempts.sort((a, b) => b.attemptId - a.attemptId);

    }//);
    setIsEssayListLoaded(true);
    setIsEssayListLoading(false);
    var _list = [...AppHelper.sortList(_res.data, 'tCode', 2)];
    if(AppHelper.sampleEssay()){
      _list = _list.filter(r=>r.essayId != AppHelper.sampleEssay().essayId);
      _list.push(AppHelper.sampleEssay())
    }
    setEssayList(_list);
    if(argEssayId){
      essaySelectByList(argEssayId, _list);
    }
  };
  const essaySelect = (argEssayId)=>{
    var _list = [...essayList];
    _list.forEach(x=>{
      x.selected = x.essayId == argEssayId ? '1' : '0';
    });
    setEssayList(_list);
  }
  
  const essaySelectAttempt = (argEssayId, argParentId)=>{
	 
    var _list = [...essayList];
	
    _list.forEach(x=>{
      x.selected = x.essayId == argEssayId || x.essayId == argParentId 
	  || (x.essayAttempt && x.essayAttempt.some((x)=>x.essayId == argEssayId))
	  ? '1' : '0';
    });
    setEssayList(_list);
  }
  
  const essaySelectByList = (argEssayId, _list)=>{
    _list.forEach(x=>{
      x.selected = x.essayId == argEssayId ? '1' : '0';
    });
    setEssayList(_list);
  }
  const essayRemove = (argEssayId)=>{
    var _list = [...essayList];
    _list = _list.filter(x=>x.essayId != argEssayId);
    _list.map(x=>x.selected = 0);
    setEssayList(_list);
  }

  return (
    <EssayContext.Provider value={{essayList, setEssayList, loadEssayList, isEssayListLoaded, setIsEssayListLoaded, essaySelect, essaySelectAttempt, isEssayListLoading, essayRemove}}>
      { children }
    </EssayContext.Provider>
  )
}
